export default {
    title: 'Catégories',
    subtitle: 'Liste des catégories',
    createCategory: 'Créer une Catégorie',
    createSubtitle: 'Ajouter une nouvelle catégorie pour organiser vos ressources',
    editCategory: 'Modifier la Catégorie',
    editTitle: 'Modifier la Catégorie',
    editSubtitle: 'Mettre à jour les informations de la catégorie',
    createSuccess: 'Catégorie créée avec succès',
    createError: 'Échec de la création de la catégorie',
    updateSuccess: 'Catégorie mise à jour avec succès',
    updateError: 'Échec de la mise à jour de la catégorie',
    loadError: 'Échec du chargement de la catégorie',
    notFound: 'Catégorie introuvable',
    images: 'Images',
    categoryForm: {
        name: 'Nom de la Catégorie',
        nameRequired: 'Le nom de la catégorie est requis',
        nameMinLength: 'Le nom de la catégorie ne peut pas être vide',
        namePlaceholder: 'Entrez le nom de la catégorie',
        description: 'Description',
        descriptionPlaceholder: 'Entrez la description de la catégorie (optionnel)',
        color: 'Couleur',
        colorPattern: 'La couleur doit être un code hex valide (ex: #007bff)',
        preview: 'Aperçu'
    },
    categoryView: {
        loading: 'Chargement de la catégorie...',
        fetchError: 'Échec du chargement de la catégorie',
        errorTitle: 'Erreur',
        notFound: 'Catégorie introuvable',
        createdAt: 'Créée',
        updatedAt: 'Modifiée',
        resourcesInCategory: 'Ressources de cette catégorie',
        resourcesDescription: 'Toutes les ressources de la catégorie {{categoryName}}'
    },
    categoriesAdmin: {
        createTitle: 'Créer une Catégorie',
        editTitle: 'Modifier la Catégorie',
        deleteTitle: 'Supprimer la Catégorie',
        createSuccess: 'Catégorie créée avec succès',
        updateSuccess: 'Catégorie mise à jour avec succès',
        deleteSuccess: 'Catégorie supprimée avec succès',
        createError: 'Échec de la création de la catégorie',
        updateError: 'Échec de la mise à jour de la catégorie',
        deleteError: 'Échec de la suppression de la catégorie',
        deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cette catégorie ? Cette action est irréversible.'
    }
};
